export default class InputPopupSelectorEvent extends Event {
	/**
	 * The static BLURRED type is dispatched when the child InputField is focused and the user tabs out or click somewhere else on the screen.
	 *
	 * Example: addEventListener(InputPopupSelectorEvent.BLURRED, (event: InputPopupSelectorEvent) => {});
	 */
	public static BLURRED = 'InputPopupSelectorEvent.blurred';
	/**
	 * The static CHANGED type is dispatched when the child InputField text is changed by the user by typing, clipping or pasting into the InputField.
	 *
	 * Example: addEventListener(InputPopupSelectorEvent.CHANGED, (event: InputPopupSelectorEvent) => {});
	 */
	public static CHANGED = 'InputPopupSelectorEvent.changed';
	/**
	 * The static CLICKED type is dispatched when the child Popup Button is clicked or while focused, the Space or Enter key is pressed.
	 *
	 * Example: addEventListener(InputPopupSelectorEvent.CLICKED, (event: InputPopupSelectorEvent) => {});
	 */
	public static CLICKED = 'InputPopupSelectorEvent.clicked';
	/**
	 * The static FOCUSED type is dispatched when the child InputField is focused with a Pointer click or being tabbed into.
	 *
	 * Example: addEventListener(InputPopupSelectorEvent.FOCUSED, (event: InputPopupSelectorEvent) => {});
	 */
	public static FOCUSED = 'InputPopupSelectorEvent.focused';
	/** All event types will set the InputField.text property to the current text content of the child InputField. */
	public text: string;
	/**
	 * The InputPopupSelectorEvent will be dispatched everytime the user focuses, blurs og change the child InputField or click the Popup Button.
	 *
	 * @param type InputPopupSelectorEvent.blurred | InputPopupSelectorEvent.changed | InputPopupSelectorEvent.focused
	 * @param text The current text content of the child InputField
	 */
	public constructor(type: string, text: string) {
		assertIsValidType(type);
		assertIsString(text);
		super(type, { bubbles: true });
		this.text = text;
	}
}

function assertIsString(value: unknown): asserts value is string {
	if (typeof value === 'string') {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type string`);
}

function assertIsValidType(value: unknown): asserts value is string {
	if (value === InputPopupSelectorEvent.BLURRED || value === InputPopupSelectorEvent.CHANGED || value === InputPopupSelectorEvent.CLICKED || value === InputPopupSelectorEvent.FOCUSED) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be InputPopupSelectorEvent.BLURRED, InputPopupSelectorEvent.CHANGED, InputPopupSelectorEvent.CLICKED or InputFieldEvent.FOCUSED`);
}
